import { Box } from "@mui/system";
import React from "react";

const Container = ({ children }) => {
  return (
    <Box
      sx={{
        ...styles.container,
        scrollbarColor: "#4f473c",
        scrollbarWidth: "200px",
        overflowX: "none",
        overflow:'hidden'
      }}
    >
      {children}
    </Box>
  );
};

const styles = {
  container: {
    width: "100%",
    gap: "0px",

    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    overflowX: "none",
    alignItems: "center",
    margin: "0px auto",
  },
};

export default Container;
